/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type EditWidgetDialog_surveys = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditWidgetDialog_surveys",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "WidgetForm_surveys",
      "args": null
    }
  ],
  "type": "SurveyConnection"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/WidgetMenu/components/EditWidgetDialog/__generated__/EditWidgetDialog_surveys.graphql.js